import { theme } from 'antd';
import React from 'react';
import { DeleteOrganisationModal } from 'zComponents/atoms';
import { Flex, Typography } from 'zui/Antd';

const { Text } = Typography;

const DeleteOrganisationSetting = () => {
	//Hooks
	const {
		token: { paddingLG, borderRadiusLG, paddingMD, colorError, paddingXXS, fontSizeLG, colorErrorText }
	} = theme.useToken();

	return (
		<Flex
			align='center'
			justify='space-between'
			style={{
				marginBottom: paddingLG,
				borderRadius: borderRadiusLG,
				padding: `${paddingMD}px ${paddingLG}px`,
				border: `1px solid ${colorError}`
			}}
		>
			<Flex vertical gap={paddingXXS}>
				<Text style={{ fontSize: fontSizeLG, lineHeight: '24px' }} strong>
					Delete this organisation
				</Text>
				<Text style={{ color: colorErrorText, lineHeight: '22px' }}>
					Deleting an organisation will permanently remove all associated data, including users, teams, and
					records. This action is irreversible.
				</Text>
			</Flex>

			<DeleteOrganisationModal />
		</Flex>
	);
};

export default DeleteOrganisationSetting;
